import * as RadixSlider from "@radix-ui/react-slider";
import styles from "./styles.module.scss";

interface SliderProps {
  value: string;
  onChange(value: string): void;
  max: string;
  min: string;
}

export function Slider({ value, onChange, max, min }: SliderProps) {
  return (
    <RadixSlider.Root
      className={styles.root}
      value={[parseInt(value)]}
      onValueChange={(v) => onChange(v[0].toString())}
      max={parseInt(max)}
      min={parseInt(min)}
      step={1}
    >
      <RadixSlider.Track className={styles.track} />
      <RadixSlider.Thumb className={styles.thumb} aria-label="Year" />
    </RadixSlider.Root>
  );
}
